import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule,OnInit } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {  TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import { PopupBoxesModule } from 'ng6-popup-boxes';
import { ToastrModule } from 'ng6-toastr-notifications';
import { DatePipe } from '@angular/common';
import { NgxSelectModule } from 'ngx-select-ex';
import { StorageServiceModule} from 'angular-webstorage-service';

import { SettingsService } from './core/settings/settings.service';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { Inject } from '@angular/core';
import {Router} from '@angular/router';
import { SortPipe } from './sort_pipe/sort.pipe';
import { MatButtonModule } from '@angular/material/button';



// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    
}

@NgModule({
    declarations: [
        AppComponent,SortPipe
    ],
    imports: [
        HttpClientModule,
        BrowserAnimationsModule, // required for ng2-tag-input
        CoreModule,
        StorageServiceModule,
        LayoutModule,
        PopupBoxesModule.forRoot(),
        ToastrModule.forRoot(),
        SharedModule.forRoot(),
        RoutesModule,
        NgxSelectModule,
        MatButtonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })
    ],
  
    providers: [DatePipe,SortPipe],
    bootstrap: [AppComponent]
})


export class AppModule implements OnInit { 
    userid:any;
    constructor(public settings: SettingsService,public router: Router,
        @Inject(LOCAL_STORAGE)private storage: WebStorageService) { }
    ngOnInit() {
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            if (target.tagName === 'A') e.preventDefault();
        })
        this.userid= this.storage.get("logdata");
    // if (this.userid == null || this.userid == undefined || this.userid == "") {
    //   this.router.navigate(['login']);
    // }
    }
}
